module.exports = __webpack_public_path__ + "img/newParticipant_ATTIKH_PUSH_1440X720.ab6fdc52.jpg";